import React from 'react';
import { X } from 'lucide-react';
import '../PurchaseRequiredModal/PurchaseRequiredModal.css';

interface PurchaseRequiredModalProps {
  onClose: () => void;
}

const PurchaseRequiredModal: React.FC<PurchaseRequiredModalProps> = ({ onClose }) => {
  const handleSubscribeClick = () => {
    onClose();
    setTimeout(() => {
      const subscriptionSection = document.querySelector('#subscription-section');
      if (subscriptionSection) {
        subscriptionSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          <X size={24} />
        </button>

        <h2 className="modal-title">Subscription Required</h2>

        <div className="modal-content">
          <p>To access this feature, you need to subscribe to one of our plans first.</p>
          <p>Choose a subscription plan to unlock all HomeCookt features and start earning or ordering delicious meals!</p>
        </div>

        <button className="subscribe-button1" onClick={handleSubscribeClick}>
          View Subscription Plans
        </button>
      </div>
    </div>
  );
};

export default PurchaseRequiredModal;
